import(/* webpackMode: "eager", webpackExports: ["CommunityDiscoveryClientContainer","WaitlistCommunityDiscoveryClient"] */ "/vercel/path0/src/app/discovery/communities/_components/CommunityDiscoveryClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/discovery/communities/_components/MeetLikeMindedPeople.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/discovery/communities/_components/WhatCommunities.tsx");
